<template>
  <div class="plugin-wrapper breadcrumb show-for-md">
    <div class="layout">
      <div class="ms-row">
        <div class="col-xs-12">
          <ul class="main-content no-bullet">
            <li class="breadcrumb__item">
              <router-link to="/" class="breadcrumb__item-link link-with-arrow link-with-arrow--secondary">
                <span>首页</span>
              </router-link>
            </li>
            <template v-for="(item, index) in config.items">
              <li class="breadcrumb__item" :key="index">
                <template v-if="item.href">
                  <router-link :to="item.href" class="breadcrumb__item-link link-with-arrow link-with-arrow--secondary">
                    <span>{{item.text}}</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="breadcrumb__item-link link-with-arrow link-with-arrow--secondary breadcrumb__item-link--not-clickable">
                    <span>{{item.text}}</span>
                  </a>
                </template>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    config: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .breadcrumb__item {
    display: inline-block; position: relative; padding: 1.25rem .625rem; 
    font-family: HelveticaNeueLTW05-45Light,arial,sans-serif;
    font-size: .625rem; text-transform: capitalize; color: #000;
    &:first-of-type { padding-left: 0; }
    &:last-of-type {
      padding-right: 0;
      .breadcrumb__item-link:after { content: none; }
    }
  }
  .breadcrumb__item-link {
    font-family: HelveticaNeueLTW05-45Light,arial,sans-serif; font-size: .625rem; text-decoration: none; color: #000;
    &:after { top: 50%; transform: translateY(-50%) translateY(.5px) rotate(90deg); }
  }
  .breadcrumb__item-link--not-clickable { pointer-events: none; }
  @media screen and (min-width: 64em) {
    .breadcrumb { padding: 0 1.875rem; }
  }
  @media screen and (min-width: 75em) {
    .breadcrumb { padding: 0; }
  }
</style>